import { genres } from '@/lib/utils/genres-shared';

export function getGenreHierarchy() {
  const hierarchy: { [key: string]: { [key: string]: string[] } } = {};
  genres.forEach(item => {
    if (!hierarchy[item.genre]) {
      hierarchy[item.genre] = {};
    }
    if (item.subgenres) {
      item.subgenres.forEach(subItem => {
        if (!hierarchy[item.genre][subItem.subgenre]) {
          hierarchy[item.genre][subItem.subgenre] = [];
        }
        if (subItem.forms) {
          subItem.forms.forEach(formItem => {
            hierarchy[item.genre][subItem.subgenre].push(formItem.form);
          });
        }
      });
    }
  });
  return hierarchy;
}

export function getFormsForGenreSubgenre(genre: string, subgenre: string) {
  const genreItem = genres.find(item => item.genre === genre);
  if (!genreItem) return [];

  const subgenreItem = genreItem.subgenres.find(item => item.subgenre === subgenre);
  if (!subgenreItem) return [];

  return subgenreItem.forms.map(form => form.form);
}

export function getSubgenresForGenre(genre: string) {
  const genreItem = genres.find(item => item.genre === genre);
  if (!genreItem) return [];
  return genreItem.subgenres.map(item => item.subgenre);
}

export function getAllGenres() {
  return genres.map(item => item.genre);
}

export function isValidGenreCombo(genre: string, subgenre: string, form: string) {
  const genreItem = genres.find(item => item.genre === genre);
  if (!genreItem) return false;

  const subgenreItem = genreItem.subgenres.find(item => item.subgenre === subgenre);
  if (!subgenreItem) return false;

  // If subgenre has no forms, empty form is valid
  if (subgenreItem.forms.length === 0) {
    return !form || form === '';
  }

  // If subgenre has forms, form must be one of them
  return subgenreItem.forms.some(item => item.form === form);
}

export function getGenreInfo(genre: string, subgenre: string, form: string) {
  const genreItem = genres.find(item => item.genre === genre);
  if (!genreItem) return undefined;

  const subgenreItem = genreItem.subgenres.find(item => item.subgenre === subgenre);
  if (!subgenreItem) return undefined;

  const formItem = subgenreItem.forms.find(item => item.form === form);
  if (!formItem) return undefined;

  return {
    genre,
    subgenre,
    ...formItem
  };
}

export function getSubgenreInfo(genre: string, subgenre: string) {
  const genreItem = genres.find(item => item.genre === genre);
  if (!genreItem) return undefined;

  const subgenreItem = genreItem.subgenres.find(item => item.subgenre === subgenre);
  if (!subgenreItem) return undefined;

  return {
    genre,
    ...subgenreItem
  };
}

export function getTopLevelGenreInfo(genre: string) {
    const genreItem = genres.find(item => item.genre === genre);
    if (!genreItem) return undefined;
    return genreItem;
}

export function getPassageContext(passage: Passage): string {
    const { book, ref, genre, subgenre, form } = passage;
    let contextString = `This is a passage from ${book} with reference ${ref}.`;
    if (genre) {
        contextString += ` The literary genre is ${genre}`;
        if (subgenre) {
            contextString += `, specifically ${subgenre}`;
        }
        if (form) {
            contextString += `, and the form is ${form}.`;
        } else {
            contextString += `.`;
        }
    }
    return contextString;
}
